exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/* Intentionally empty */", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /home/agira/Desktop/BU-Intra/agira-intranet-ui/src/app/authentication/sso-handler/sso-handler.component.css
// module id = ../../../../../src/app/authentication/sso-handler/sso-handler.component.css
// module chunks = main